<template functional>
  <div style="align-content: center">
    <div
      v-if="
        props.row.approval_range_details &&
        props.row.approval_range_details.length
      "
    >
      <div
        v-for="(detail, index) in props.row.approval_range_details"
        :key="index"
      >
        <div v-if="detail.max_value">
          <strong
            ><translate-text keyTranslate="shopping.range" /> {{ index + 1 }}:
          </strong>
          {{ detail.max_value }}
          {{ detail.max_operator }}
          <br />
        </div>
        <div v-else>
          <strong
            ><translate-text keyTranslate="shopping.range" /> {{ index + 1 }}:
          </strong>
          N/A
        </div>
      </div>
    </div>
    <div v-else>
      <translate-text keyTranslate="shopping.no_approval_details" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FinalValueColumn',
};
</script>
